import React from 'react';
import { Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

type ApiRequestDetailsModalProps = {
  showModal: boolean;
  params: string | null;
  onClose: () => void;
};

const ApiRequestDetailsModal: React.FC<ApiRequestDetailsModalProps> = ({
  showModal,
  params,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('api:requestDetails')}
      open={showModal}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <div className="api-request-details-modal">
        <div className="api-request-details-modal__header">
          <Paragraph
            copyable={{ text: params || '' }}
            className="api-request-details-modal__copy"
          />
        </div>
        <pre className="api-request-details-modal__content">{params || ''}</pre>
      </div>
    </Modal>
  );
};

export default ApiRequestDetailsModal;
